function initSiteCallout() {
  const callout = document.querySelector(".site-callout");

  if (!callout) {
    return;
  }

  const hero = document.querySelector(".hero");
  const footer = document.querySelector(".site-footer");

  function isPastThreshold() {
    if (hero) {
      return hero.getBoundingClientRect().bottom <= 0;
    }

    return window.scrollY >= window.innerHeight;
  }

  function isNearFooter() {
    if (!footer) {
      return false;
    }

    return footer.getBoundingClientRect().top <= window.innerHeight * 0.85;
  }

  function update() {
    const show = isPastThreshold() && !isNearFooter();
    callout.classList.toggle("site-callout--visible", show);
  }

  update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update, { passive: true });
}

initSiteCallout();
